import React, { useEffect, useState, useRef } from 'react';

import Link from '../components/Link';
import { videoJson } from '../data/Data';

const allVideos = Object.values(videoJson);

const Video = ({ video }) => {
  const videoRef = useRef(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPlaying, setIsPlaying] = useState(true);
  const [isMuted, setIsMuted] = useState(false);
  const isPlaylist = video === 'all';

  let videoSrc = '';
  let videoTitle = '';
  let videoBack = '';

  if (isPlaylist) {
    const currentVideo = allVideos[currentIndex];
    videoSrc = currentVideo?.src || '';
    videoTitle = currentVideo?.name || 'All PSO Van Videos';
    videoBack = '/home/';
  } else {
    videoSrc = videoJson?.[video]?.src;
    videoTitle = videoJson?.[video]?.name;
    videoBack = videoJson?.[video]?.back_button;
  }

  // Ensure video starts muted for autoplay compatibility
  useEffect(() => {
    if (videoRef.current) {
      //videoRef.current.muted = true;
    }
  }, []);

  useEffect(() => {
    setCurrentIndex(0);
  }, [video]);

  useEffect(() => {
    const player = videoRef.current;
    if (!player || !videoSrc) {
      return;
    }

    player.load();
    player.play().then(() => {
      setIsPlaying(true);
    }).catch(() => {
      setIsPlaying(false);
    });
  }, [videoSrc]);

  const handleEnded = () => {
    if (!isPlaylist) {
      return;
    }

    setCurrentIndex((index) => (index + 1) % allVideos.length);
  };

  const handleRewind = () => {
    const player = videoRef.current;
    if (!player) {
      return;
    }

    player.currentTime = 0;
  };

  const handlePlayPause = () => {
    const player = videoRef.current;
    if (!player) {
      return;
    }

    if (player.paused) {
      player.play().then(() => {
        setIsPlaying(true);
      }).catch(() => {});
    } else {
      player.pause();
      setIsPlaying(false);
    }
  };

  const handleMuteToggle = () => {
    const player = videoRef.current;
    if (!player) {
      return;
    }

    player.muted = !player.muted;
    setIsMuted(player.muted);
  };

  const handlePreviousVideo = () => {
    setCurrentIndex((index) => (index - 1 + allVideos.length) % allVideos.length);
  };

  const handleNextVideo = () => {
    setCurrentIndex((index) => (index + 1) % allVideos.length);
  };
  
  return (
    <div className="page-container w-full h-full bg-cover bg-center relative">
      <div className="absolute-center flex flex-col items-center" style={{width:'75vw'}}>
        <video
          ref={videoRef}
          key={isPlaylist ? `${currentIndex}-${videoSrc}` : videoSrc}
          controls={false}
          title={videoTitle}
          className='videoplayer shadow-lg shadow-gray-500 w-full'
          playsInline
          autoPlay
          loop={!isPlaylist}
          src={videoSrc}
          onEnded={handleEnded}
          onPlay={() => setIsPlaying(true)}
          onPause={() => setIsPlaying(false)}
          onVolumeChange={(event) => setIsMuted(event.target.muted)}
        ></video>
        <div className="flex items-center justify-center pt-10" style={{gap:'2vw'}}>
          {isPlaylist && (
            <button
              type="button"
              onClick={handlePreviousVideo}
              className="flex items-center justify-center rounded-full bg-white text-gray-800 opacity-90 shadow-md shadow-gray-500"
              style={{width:'3vw', height:'3vw', fontSize:'1.2vw', padding:'0.5vw'}}
              aria-label="Previous video"
            >
              <i className="fa-solid fa-backward-step"></i>
            </button>
          )}
          <button
            type="button"
            onClick={handleRewind}
            className="flex items-center justify-center rounded-full bg-white text-gray-800 opacity-90 shadow-md shadow-gray-500"
            style={{width:'3vw', height:'3vw', fontSize:'1.2vw', padding:'0.5vw'}}
            aria-label="Rewind to beginning"
          >
            <i className="fa-solid fa-backward"></i>
          </button>
          <button
            type="button"
            onClick={handlePlayPause}
            className="flex items-center justify-center rounded-full bg-white text-gray-800 opacity-90 shadow-md shadow-gray-500"
            style={{width:'4vw', height:'4vw', fontSize:'1.5vw', padding:'1.2vw'}}
            aria-label={isPlaying ? 'Pause' : 'Play'}
          >
            <i className={isPlaying ? 'fa-solid fa-pause' : 'fa-solid fa-play'}></i>
          </button>
          <button
            type="button"
            onClick={handleMuteToggle}
            className="flex items-center justify-center rounded-full bg-white text-gray-800 opacity-90 shadow-md shadow-gray-500"
            style={{width:'3vw', height:'3vw', fontSize:'1.2vw', padding:'0.5vw'}}
            aria-label={isMuted ? 'Unmute' : 'Mute'}
          >
            <i className={isMuted ? 'fa-solid fa-volume-xmark' : 'fa-solid fa-volume-high'}></i>
          </button>
          {isPlaylist && (
            <button
              type="button"
              onClick={handleNextVideo}
              className="flex items-center justify-center rounded-full bg-white text-gray-800 opacity-90 shadow-md shadow-gray-500"
              style={{width:'3vw', height:'3vw', fontSize:'1.2vw', padding:'0.5vw'}}
              aria-label="Next video"
            >
              <i className="fa-solid fa-forward-step"></i>
            </button>
          )}
        </div>
      </div>
      <Link to={videoBack}>
        <img src='./assets/exit.png' className='absolute bottom-10 right-10' style={{width:'5vw'}} alt='Back Button' />
      </Link>
    </div>
  )
}

export default Video